<template>
  <div>
    <div class="modal__item-row">
      <TextEditor v-model="note"></TextEditor>
    </div>
    <div class="grid modal__item-row">
      <div class="grid__col--4"></div>
      <div class="grid__col--4">
        <button class="btn btn-primary" @click.stop="submitComment" :disabled="!formValid">Submit Comment</button>
      </div>
      <div class="grid__col--4"></div>
    </div>
  </div>
</template>

<script>
  import TextEditor from './TextEditor.vue';

  export default {
    name: 'CommentForm',
    components: {
      TextEditor,
    },
    data() {
      return {
        note: '',
      };
    },
    computed: {
      formValid() {
        return this.note !== '';
      },
    },
    methods: {
      submitComment() {
        this.$store.dispatch('meetingAgendas/submitComment', this.note);
        this.note = '';
      },
    },
  };
</script>
